/**
 * @generated SignedSource<<b54eb7b29f3aa208bd6decedb8fce5ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventFiltersFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventFiltersTotalCountFragment" | "TagsFieldsFragment">;
  readonly " $fragmentType": "EventFiltersFragment";
};
export type EventFiltersFragment$key = {
  readonly " $data"?: EventFiltersFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventFiltersFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventFiltersFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "activityKind",
          "value": "EVENT"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TagsFieldsFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "FragmentSpread",
      "name": "EventFiltersTotalCountFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b2eeec3f177409a1fe41b559a38237cb";

export default node;
